import { metadataState } from './metadata/metadata.reducer';
import type { MetadataState } from './metadata/metadata.types';

interface MigrationState {
  metadata: MetadataState;
}

// biome-ignore lint/suspicious/noExplicitAny: Redux Persist requires 'any' in migration type due to potential unknown state shape
export const migrations: Record<number, (state: any) => MigrationState> = {
  //there is wrong typing inside redux persist, https://github.com/rt2zz/redux-persist/issues/1065#issuecomment-554538845
  3: (state: { metadata: MetadataState }) => ({
    ...state,
    metadata: metadataState,
  }),
  4: (state: { metadata: MetadataState }) => ({
    ...state,
    metadata: { ...state.metadata, pointsOfSale: [] },
  }),
};
